export interface Settings {
  currencySymbol: string;
  currencyRounding: number;
}

export const DEFAULT_SETTINGS: Settings = {
  currencySymbol: "£",
  currencyRounding: 2,
};

export function loadSettings(): Settings {
  try {
    const savedSettings = localStorage.getItem("settings");
    if (savedSettings) {
      const parsed = JSON.parse(savedSettings);
      // Validate the parsed settings
      if (
        typeof parsed.currencySymbol === "string" &&
        typeof parsed.currencyRounding === "number"
      ) {
        return parsed;
      }
    }
  } catch (error) {
    console.error("Error loading settings:", error);
  }
  return DEFAULT_SETTINGS;
}

export function saveSettings(settings: Settings): void {
  try {
    localStorage.setItem("settings", JSON.stringify(settings));
  } catch (error) {
    console.error("Error saving settings:", error);
  }
}
